var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero-banner"},[_c('h1',{staticClass:"hero-banner__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('h2',{staticClass:"hero-banner__subtitle",domProps:{"innerHTML":_vm._s(_vm.subtitle)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }